<template>
  <div>Silicon Practice Logo</div>
</template>